import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-01/lesson-14/task-01";

const task: Slide = {
  titleHtml: `
  This is about the notion of acoustic short circuit (anti-noise). One wishes to limit the radiation of a monopole<br>source of volume velocity 2Q by placing, on both side and at a distance d from it, two monopole sources "anti-noise",<br>i.e. in phase opposition (volume velocity -Q). Calculate the attenuation A that can be obtained this way along the axis<br>(where A is minimal) in dB with d = 5 cm and f = 50 Hz then 500 Hz (celerity in air is 340 m/s).`,
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/14/task/task-1.svg`,
                },
              },
              styles: {
                padding: "2% 0",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
